import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  SshSecurityInfo,
  API_PATH_SSH_SECURITY_INFOS,
} from './sshSecurityInfo.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

// eslint-disable-next-line import/prefer-default-export
export function getSshSecurityInfos(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<SshSecurityInfo>> {
  return http.get(`${API_PATH_SSH_SECURITY_INFOS}/${deliveryFunctionId}`);
}

export function getSshSecurityInfo(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<SshSecurityInfo>> {
  return http.get(`${API_PATH_SSH_SECURITY_INFOS}/${deliveryFunctionId}/${id}`);
}

export function getSshSecurityInfosList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<SshSecurityInfo>> {
  return http.get(`${API_PATH_SSH_SECURITY_INFOS}/${deliveryFunctionId}`);
}

export function createSshSecurityInfos(
  deliveryFunctionId: string,
  body: WithAuditDetails<SshSecurityInfo>,
): AxiosPromise<ServerResponse<SshSecurityInfo>> {
  return http.post(`${API_PATH_SSH_SECURITY_INFOS}/${deliveryFunctionId}`, body);
}

export function updateSshSecurityInfos(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<SshSecurityInfo>,
): AxiosPromise<ServerResponse<SshSecurityInfo>> {
  return http.put(`${API_PATH_SSH_SECURITY_INFOS}/${deliveryFunctionId}/${id}`, body);
}

export function deleteSshSecurityInfo(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<SshSecurityInfo>> {
  return http.delete(`${API_PATH_SSH_SECURITY_INFOS}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
